import { render, staticRenderFns } from "./SetVisitType.vue?vue&type=template&id=69ec19a2&"
import script from "./SetVisitType.vue?vue&type=script&lang=js&"
export * from "./SetVisitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69ec19a2')) {
      api.createRecord('69ec19a2', component.options)
    } else {
      api.reload('69ec19a2', component.options)
    }
    module.hot.accept("./SetVisitType.vue?vue&type=template&id=69ec19a2&", function () {
      api.rerender('69ec19a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/SetVisitType.vue"
export default component.exports